document.addEventListener("DOMContentLoaded", function () {

    class ProductUtility {
        constructor() {
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.cartMethods = this.initializeCartMethods();
        }

        initializeCartMethods() {
            if (!this.cart) return {};

            const { renderContents, getSectionsToRender } = this.cart;

            return {
                addProperty: getSectionsToRender ? getSectionsToRender.bind(this.cart) : null,
                updateCart: renderContents ? renderContents.bind(this.cart) : null,
                updateCartStatus: () => {
                    if (this.cart.classList.contains('is-empty')) {
                        this.cart.classList.remove('is-empty');
                    }
                }
            };
        }
    }

    const productUtility = new ProductUtility();

    async function addToCartProduct(event) {
        const { cartMethods } = productUtility;
        const fetchConfig = createFetchConfig(event.dataset.product, cartMethods);

        try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, fetchConfig);
            const data = await response.json();

            updateCartStatusAndContents(cartMethods, data);

        } catch (error) {
            console.error('Error adding product to cart:', error);
        }
    }

    function createFetchConfig(productId, cartMethods) {
        const formData = {
            'items': [
                {
                    "id": productId,
                    "quantity": 1
                }
            ]
        };

        if (cartMethods.addProperty) {
            formData.sections = cartMethods.addProperty().map((section) => section.id);
        }

        return {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        };
    }

    async function updateCartStatusAndContents(cartMethods, data) {
        if (cartMethods.updateCartStatus) {
            cartMethods.updateCartStatus();
        }
        if (cartMethods.updateCart) {
            await cartMethods.updateCart(data);
        }
    }

    window.addToCartProduct = addToCartProduct;

});
